import _ from 'lodash';
import { apiSearch, apiFetch, apiRemove } from '../utility';

const apiBase = 'inventoryAllocation.fuelMaintenanceCost';
const base = 'fuelMaintenanceCost';

export const search = (p = {}) => {
	const {callback = _.noop} = p;
	return dispatch => {
		apiSearch({
			apiMethod : `${apiBase}.search`,
			base,
			dispatch,
			callback,
		});
	};
};

export const get = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.get`,
			params,
			dispatch,
			callback,
		});
	};
};

export const add = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.add`,
			listNameToUpdate : 'fuelMaintenanceCostId',
			params,
			dispatch,
			callback,
		});
	};
};

export const update = ({params, callback = _.noop}) => {
	return dispatch => {
		apiFetch({
			method: `${apiBase}.update`,
			params,
			dispatch,
			callback,
		});
	};
};

export const remove = ({fuelMaintenanceCostId, callback = _.noop}) => {
	return dispatch => {
		apiRemove({
			base : apiBase,
			id : fuelMaintenanceCostId,
			dispatch,
			callback,
		});
	};
};
